export default function Rules() {
	return <section id="rules">
		<h1>Rules</h1>
		<div className="rules">
			<h2>Conduct</h2>
			<ol>
				<li>Rule 1</li>
				<li>Rule 2</li>
				<li>Rule 3</li>
				<li>Rule 4</li>
			</ol>
			<h2>List 2</h2>
			<ol>
				<li>Rule 1</li>
				<li>Rule 2</li>
				<li>Rule 3</li>
				<li>Rule 4</li>
			</ol>
			<h2>List 3</h2>
			<ol>
				<li>Rule 1</li>
				<li>Rule 2</li>
				<li>Rule 3</li>
				<li>Rule 4</li>
			</ol>
			<h2>List 4</h2>
			<ol>
				<li>Rule 1</li>
				<li>Rule 2</li>
				<li>Rule 3</li>
				<li>Rule 4</li>
			</ol>
			<h2>List 5</h2>
			<ol>
				<li>Rule 1</li>
				<li>Rule 2</li>
				<li>Rule 3</li>
				<li>Rule 4</li>
			</ol>
		</div>
	</section>
}
